
export class ProductReviewScreenModel {
    /** 商品ID */
    productId: string | null = null;
    /** レビューセットID */
    reviewSetId: string | null = null;
}
